// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#PrefsParams .disabled {
  position: relative;
  border-color: rgba(120, 122, 145, 0.67) !important;
}
#PrefsParams .disabled:after {
  content: "";
  background-color: rgba(120, 122, 145, 0.67);
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
}`, "",{"version":3,"sources":["webpack://./src/pages/administration/prefs-params/PrefParams.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;EACA,kDAAA;AAAR;AAEQ;EACI,WAAA;EACA,2CAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;AAAZ","sourcesContent":["#PrefsParams {\n    .disabled {\n        position: relative;\n        border-color: rgba(120, 122, 145, .67) !important;\n\n        &:after {\n            content: \"\";\n            background-color: rgba(120, 122, 145, .67);\n            position: absolute;\n            top: 0;\n            bottom: 0;\n            left: 0;\n            right: 0;\n            z-index: 10;\n        }\n\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
